// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"390":"f194fe7e","654":"7f448851","716":"f18a27c9"}[chunkId] + ".chunk.css";
};